import { getLocalizedStrings } from '../profileSettingsLocalizedStrings';
import classes from './manageAccount.scss';
import Switch from "react-switch";
import CheckBox from '../Common/scePSCheckBox';
import SceButton from '../../Common/CommonComponents/sceButton';
import PSErrCard from '../Common/profileSettingsErrCard';
import AppSpinner from '../../Common/CommonComponents/AppSpinner/appSpinner';
import ViewEditEnrolledAccounts from './viewEditEnrolledAccounts';
import FocusTrap from "focus-trap-react";
import { Fragment } from 'react';

class DeactivateAccountPopup extends React.Component{

    constructor(props) {
        super(props);        
        this.strings = getLocalizedStrings('ManageAccount');
        this.state = {
            showMultiAccountView: false, programEnrollmentDetails: '', checkBoxSelected: false, showDeactivateError: false, showViewEditView: '',
            isLoading:false,
            progList: {
                DP: {id: 'autoPaySwitch', heading: this.strings.autoPay, isChecked: true, isError: false, hideForWebuser: true, isSelectAll: true, unSelectedAccounts: new Map()},
                PAPR: {id: 'paprBillSwitch', heading: this.strings.paperlessBilling, isChecked: true, isError: false, hideForWebuser: true, isSelectAll: true, unSelectedAccounts: new Map()},
                OUTGEA: {id: 'outageSwitchEa', heading: this.strings.outageAlertsEa, isChecked: true, isError: false, hideForWebuser: false, isSelectAll: true, unSelectedAccounts: new Map()},
                OUTGRM: {id: 'outageSwitchRm', heading: this.strings.outageAlertsRm, isChecked: true, isError: false, hideForWebuser: false, isSelectAll: true, unSelectedAccounts: new Map()},
                BUDA: {id: 'baSwitch', heading: this.strings.budgetAssistantAlerts, isChecked: true, isError: false, hideForWebuser: true, isSelectAll: true, unSelectedAccounts: new Map()},
                DEMR: {id: 'cppSwitch', heading: this.strings.cppAlerts, isChecked: true, isError: false, hideForWebuser: true, isSelectAll: true, unSelectedAccounts: new Map()},
            }
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.closeIcon=drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Close.svg';
        this.warningIcon = drupalSettings.path.baseUrl + 'themes/custom/sce_responsive/images/Icon_Warning.svg';
      }

    componentWillMount() {
        if(this.props.isMultiAccountView){
            this.setState({ showMultiAccountView: true });
        }else{
            this.setState({ showMultiAccountView: false, programEnrollmentDetails: this.props.programEnrollmentDetails },()=>{
            });
        }
    }
    componentDidMount() {

        document.addEventListener('mousedown', this.handleClickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    
    setWrapperRef(node) {
        this.wrapperRef = node;
    }
    
    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.props.closeDeactivatePopupHandler();
        //  alert("clicked");
    
        }
    }

    getFinalDeEnrollList = () => {
        let deEnrollList = [];

        _.each(this.state.programEnrollmentDetails, function(eachProgram){
            let progListItem = this.state.progList[eachProgram.dispCategory];
            if(!progListItem.isChecked) {
                deEnrollList.push({...eachProgram, unSelectedAccounts: progListItem.unSelectedAccounts, isSelectAll: progListItem.isSelectAll});
            } 
        },this);

        return deEnrollList;
    }

    deActivateUser = () => {
        let deEnrollList = this.getFinalDeEnrollList();
        app.profileSettingsService.deActivateUserV2(deEnrollList, this.props.bpNumber).then((response) => {
            this.setState({ showDeactivateError: false });
              app.identityService.logout().then((response) => {
                app.identityService.handleUserLogout();
                app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.HOME_LOGIN);
              }, error => {
              });
            //log out the user and navigate to homepage
        }, (error) => {
            this.setState({ showDeactivateError: true });
        });
    }

    handleChange = (program, id) => {
        let updatedState = {...this.state};
        updatedState.progList[program.dispCategory].isChecked = !updatedState.progList[program.dispCategory].isChecked;
        this.setState(updatedState);
    }

    handleCheckBoxClick = () => {
        this.setState({ checkBoxSelected: !this.state.checkBoxSelected });
    }

    saveUnselectedAccounts = (unSelectedAccounts, selectAllFlow) => {
        let updatedState = {...this.state};
        this.webAnalyticsDeactivatePopup(updatedState.showViewEditView.messageType);
        updatedState.progList[updatedState.showViewEditView.dispCategory].unSelectedAccounts = unSelectedAccounts;
        updatedState.progList[updatedState.showViewEditView.dispCategory].isSelectAll = selectAllFlow;
        updatedState.showViewEditView = ''; 
        this.setState(updatedState);
    } 
webAnalyticsDeactivatePopup = (messageType,value) => {
    switch (messageType) {
        case "EBIL":
            window.aUtils.sendAAEvent("button", value === "viewEdit" ? "paperlessBillingView/Edit" : "paperlessBillingTurnOff");
            break;
        case "BUDA":
            window.aUtils.sendAAEvent("button", value === "viewEdit" ? "budgetAssistantView/Edit" : "budgetAssistantTurnOff" );
            break;
        case "EMRG":
             window.aUtils.sendAAEvent("button", value === "viewEdit" ? "emergencyview/edit" : "emergencyturnoff" );
             break;
        case "OUTG":
             window.aUtils.sendAAEvent("button", value === "viewEdit" ?  "repairandmaintenanceview/edit" : "repairandmaintenanceturnoff");
             break;
        case "CPP1":
             window.aUtils.sendAAEvent("button", value === "viewEdit" ? "criticalPeakPricingView/Edit" : "criticalPeakPricingTurnOff" );
             break;
        /* Sonar Cube fix 
          Done by : Keerthi VL
          Date : 23-01-2023
      */
        default: null;
    }
}
    toggleViewEditView = (selectedProgram) => { 
        if(selectedProgram){
            selectedProgram = {...selectedProgram, heading:this.state.progList[selectedProgram.dispCategory].heading, isSelectAll:this.state.progList[selectedProgram.dispCategory].isSelectAll}; 
            this.webAnalyticsDeactivatePopup(selectedProgram.messageType,"viewEdit");         
        }
        this.setState({showViewEditView: selectedProgram}); 
    }

    getSingleAccountView = () => {
        const cardsJSX = <div className={classes.CardPadding}><div className={classes.Card}>
            {this.props.programEnrollmentDetails.map((eachProgram)=>{
                let currentProgram = this.state.progList[eachProgram.dispCategory];
                let eaCardDisabled = eachProgram.dispCategory === "OUTGEA" && eachProgram.onlyOneBpEnrolled;
                let count = currentProgram.isSelectAll ? eachProgram.count - currentProgram.unSelectedAccounts.size : currentProgram.unSelectedAccounts.size;
                let isToggleDisabled = !currentProgram.isChecked || count < 1;
                /*  Sonar Cube fix 
                        Done by : Keerthi VL
                        Date : 23-01-2023
                */ 
                let isWebUserOrhideForWebuser = this.props.isWebUser && currentProgram.hideForWebuser;
                let errorSec = !currentProgram.isChecked ?
                <div>
                    <div className={classes.turnOffErrSec}>
                        <img className={classes.warningIcon} src={this.warningIcon} alt="Warning Icon" />
                        <div className={classes.warningMsg}>{this.strings.requestInQueue}</div>
                    </div>
                </div> :  null;
                return (
                    (parseInt(eachProgram.count) && !(isWebUserOrhideForWebuser)) && !eaCardDisabled ? <div className={classes.cardstoshow}>
                        <div>
                            <div className={classes.alertText}>
                                <div>{currentProgram.heading}</div>
                                {eachProgram.count > 1 ? 
                                    <div>
                                        <div className={'sce-space-xs '+classes.alertSubText}>{count+' '+this.strings.enrolledAccounts}</div>
                                        <div className='sce-space-xs'><button className={classes.viewEditButton} id={currentProgram.id+'viewEdit'} onClick={()=>this.toggleViewEditView(eachProgram)} disabled={!currentProgram.isChecked}>{this.strings.viewEditBtn}</button></div>
                                    </div>: null}

                            </div>
                            <span className={(eachProgram.count > 1 ?'sce-space-md ': '') + classes.alertToggle}><Switch className="react-switch" id={currentProgram.id}  checked={currentProgram.isChecked} disabled={isToggleDisabled} onChange={!isToggleDisabled ? ()=>this.handleChange(eachProgram, currentProgram.id) : null} handleDiameter={22} height={30} width={70} borderRadius={15} onColor="#64A000" offColor="#E9EAEE" uncheckedIcon={<span className={classes.Off}>Off</span>} checkedIcon={<span className={classes.On}>On</span>} /></span>
                        </div>
                        {errorSec}
                    </div>:null
                );
            })}
        </div></div>;
        
        return (
            <div>
                <div className='row'><div className={'col-sm-12 ' + classes.popUpMsgPadding}><p>{this.strings.beforeDeactivationSingleAcctMsg}</p></div></div>
                <div className='row'><div className={'col-sm-12'}>{cardsJSX}</div></div>
            </div>
        );
    }

    getMultiAccountView = () => {
        return (<div><div className='row'><div className={'col-sm-12 ' + classes.popUpMsgPadding}><p>{this.strings.beforeDeactivationMultiAcctMsg}</p></div></div></div>);
    }
  
    render(){
        const deactivateBtnJsx = this.state.checkBoxSelected ? <div className={classes.enabledDeactivateBtn}><SceButton  id='Deactivate' buttonType='default' value={this.strings.deactivateBtn} iconType='rightArrow' onClick={this.deActivateUser} /></div>
                                                :  <div className={classes.diasbledDeactivateBtn}><SceButton  id='DisabledDeactivate'  buttonType='sceDisabled' isDisabled={! this.state.checkBoxSelected}  value={this.strings.deactivateBtn} iconType='rightArrow'  /></div>;

        const view = this.state.showMultiAccountView ? this.getMultiAccountView() : this.getSingleAccountView();

        const deactivateErrorJsx = this.state.showDeactivateError ? <div className={classes.errCardPadding}><PSErrCard onFormhandler={this.deActivateUser} /></div> : null;

        const unSelectedAccounts = this.state.showViewEditView ? this.state.progList[this.state.showViewEditView.dispCategory].unSelectedAccounts : null;
        
        return(
            <FocusTrap
            focusTrapOptions={{
                allowOutsideClick: true,
            }}
 
            >
            <div>
            {this.state.isLoading && <AppSpinner />}
            
            <div tabIndex="0"  className={classes.sceOverlay}>
                <div className={classes.sceOverlayContent}>
                    <div ref={this.setWrapperRef} className={classes.sceDialogBox}>
                        <div className='row'><div className={'col-sm-12'}><span><button className={classes.iconClose} onClick={this.props.closeDeactivatePopupHandler} ><img src={this.closeIcon} alt="Close Icon"  /></button></span><div className={classes.popUpHeading}>{this.strings.deactivatePopupHeading}</div></div></div>
                        {this.state.showViewEditView ? <ViewEditEnrolledAccounts selectedProgram={this.state.showViewEditView} unSelectedAccounts={unSelectedAccounts} strings={this.strings} toggleViewEditView={this.toggleViewEditView} saveUnselectedAccounts={this.saveUnselectedAccounts} bpNumber={this.props.bpNumber} /> : <Fragment>
                            <div className={classes.scrollableContent}>
                                {deactivateErrorJsx}
                                {view}
                                <div className={classes.checkBoxPadding}><CheckBox id='deactivateCheckBox' options={this.strings.checkBoxInfo} handleClick={this.handleCheckBoxClick} selectedOptions={this.state.checkBoxSelected} /></div>
                            </div>
                        <div className={classes.buttonsPadding}>
                            <div>{deactivateBtnJsx}</div>
                            <div className={classes.CancelBtn}><SceButton  id='cancel'  buttonType='default'  value={this.strings.cancel} iconType='cancel' onClick={this.props.closeDeactivatePopupHandler} /></div>
                        </div>
                        </Fragment>
                        }
                    </div>
                </div>
            </div>
            </div>
            </FocusTrap>
        ); 
    }
}

export default DeactivateAccountPopup;